module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_32.2bdf0f05.jpg";